import { render } from "./CustomTree.vue?vue&type=template&id=07292f62&scoped=true"
import script from "./CustomTree.vue?vue&type=script&lang=js"
export * from "./CustomTree.vue?vue&type=script&lang=js"

import "./CustomTree.vue?vue&type=style&index=0&id=07292f62&scoped=true&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07292f62"]])

export default __exports__